import React, { Component } from "react";
import { Checkbox, Radio, Space, Spin, message } from "antd";
import Bridge from "../../utils/Bridge";
import {
  RACE_OPTIONS_ECAS,ETHNICITY_OPTIONS_ECAS
} from "../../utils/consts";

export default class GenderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: "",
      race: "",
      race_other_specification: "",
      ethnicity: "",
      ethnicity_other_specification: "",
      loading: false,
      ethnicity_option_list:[
        "Not of Hispanic, Latino/a or Spanish origin",
        "Mexican, Mexican American, Chicano/a",
        "Puerto Rican",
        "Cuban",
        "Another Hispanic Latino/a or Spanish origin",
        "Other",
        "Decline to answer",
      ],
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Physical sex at birth") {
                this.setState({ gender: item.value });
              }
              if (item.field == "Race") {
                this.setState({ race:item.value });
              }
              if (item.field == "Race Other Specification") {
                this.setState({ race_other_specification: item.value });
              }
              if (item.field == "Ethnicity") {
                this.setState({ ethnicity: item.value });
              }
              if (item.field == "Ethnicity Other Specification") {
                this.setState({ ethnicity_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeRace = (e) => {
    let value = e.target.value;
    this.setState({
      race:value,
      race_other_specification:""
    })
  };
  save = () => {
    if (!this.state.gender) {
      message.warning("Please select sex at birth");
      return;
    }    

    if (!this.state.race) {
      message.warning("Please select race");
      return;
    }
    if(this.state.race=="Other" && !this.state.race_other_specification){
      message.warning("Please enter the race specification");
      return;
    }
    if (!this.state.ethnicity) {
      message.warning("Please select ethnicity");
      return;
    }
    if(this.state.ethnicity=="Other" && !this.state.ethnicity_other_specification){
      message.warning("Please enter the ethnicity specification");
      return;
    }
    // step 2
    let questions = [
      {
        parent_field: "Physical sex at birth",
        field: "Physical sex at birth",
        value: this.state.gender,
      },
      {
        parent_field: "Race",
        field: "Race",
        value: this.state.race,
      },
      {
        parent_field: "Race Other Specification",
        field: "Race Other Specification",
        value: this.state.race_other_specification,
      },
      {
        parent_field: "Ethnicity",
        field: "Ethnicity",
        value: this.state.ethnicity,
      },
      {
        parent_field: "Ethnicity Other Specification",
        field: "Ethnicity Other Specification",
        value: this.state.ethnicity_other_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(4);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeEthnicity = (e) => {
    let value = e.target.value;
    this.setState({
      ethnicity:value,
      ethnicity_other_specification:""
    })
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>GENDER, RACE AND ETHNICITY </h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
              Sex at birth <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) => this.setState({ gender: e.target.value })}
                value={this.state.gender}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Male"}>Male</Radio>
                  <Radio value={"Female"}>Female</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Race
                <i style={{ fontWeight: "400" }}>(select all that apply)</i> <span className="text-danger">*</span>
              </label>
              <ul>
                <Radio.Group
                  onChange={this.onChangeRace}
                  value={this.state.race}
                >
                  <Space direction="vertical">
                    {RACE_OPTIONS_ECAS.map((item,index)=>(
                      <Radio value={item} key={index}>
                        {item}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </ul>
            </div>
            {this.state.race=="Other" && (
              <div className="form-group">
                <label className="input-heading">
                  Specification{" "} <span className="text-danger">*</span>
                </label>
                <br />
                <textarea
                  name="race_other_specification"
                  value={this.state.race_other_specification}
                  onChange={(e) => {
                    this.setState({
                      race_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            <div className="form-group">
              <label className="input-heading">
                Ethnicity
                <i style={{ fontWeight: "400" }}>(select all that apply)</i> <span className="text-danger">*</span>
              </label>
              <ul>
                <Radio.Group
                  onChange={this.onChangeEthnicity}
                  value={this.state.ethnicity}
                >
                  <Space direction="vertical">
                    {ETHNICITY_OPTIONS_ECAS.map((item, index) => (
                      <Radio value={item} key={index}>
                        {item}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </ul>
            </div>
            {this.state.ethnicity=="Other" && (
              <div className="form-group">
                <label className="input-heading">
                  Specification{" "} <span className="text-danger">*</span>
                </label>
                <br />
                <textarea
                  name="ethnicity_other_specification"
                  value={this.state.ethnicity_other_specification}
                  onChange={(e) => {
                    this.setState({
                      ethnicity_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(2)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
